import { routes as auth } from '../views/auth';
import { routes as accessLocations } from '../views/access-locations';
import { routes as places } from '../views/places';
import { routes as profile } from '../views/profile';
import { routes as protocols } from '../views/protocols';
import { routes as revoke } from '../views/revoke';
import { routes as activityRecords } from '../views/activity-records';

export default [
    ...auth,
    ...accessLocations,
    ...places,
    ...profile,
    ...protocols,
    ...revoke,
    ...activityRecords
  ]